// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"176":"projects","443":"about"}[chunkId] + "." + {"176":"b11dfc1e","443":"5d81cfb8"}[chunkId] + ".css";
};